/**
 * 商户评估申请
 */
import React from 'react';
import { Row, Col, Icon, Tooltip, Input, Select } from 'antd';
import PageLayout from '../../ui/PageLayout';
//车辆评估详细
import MemberValuateDetail from './MemberValuateDetail';
//车辆评估信息录入
import MemberValuateEdit from './MemberValuateEdit';
import moment from 'moment';
import http from '../../../axios/http';
//加载中遮罩
import Loading from '../../ui/Loading';
import messager from '../../ui/messager';
import { global_data } from '../../ui/auth'

class MemberValuateIndex extends React.Component {

    columns = [{
        title: '报告编码',
        dataIndex: 'valuationNo',
        width: '10%',
    }, {
        title: '委托方',
        dataIndex: 'client',
        width: '7%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '7%',
    }, {
        title: '车辆名称',
        dataIndex: 'vehicleName',
        width: '20%',
    }, {
        title: '评估等级',
        dataIndex: 'resultGrade',
        width: '10%',
    }, {
        title: '估计价值',
        dataIndex: 'valuationResult',
        width: '10%',
    }, {
        title: '评估时间',
        dataIndex: 'valuationDate',
        width: '7%',
    }, {
        title: '流程状态',
        dataIndex: 'signTaskStatus',
        format: { 9: "未发起签署", 0: "草稿", 1: "签署中", 2: "完成", 3: "撤销", 5: "过期", 7: "拒签" },
        width: '7%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("MEMBER_VALUATE_LOG_UPDATE")?
                <Tooltip title="填写评估信息">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.edit.bind(this, record)} />
                </Tooltip>
                :""}
                <Tooltip title="详细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
                {global_data.authCode.includes("MEMBER_VALUATE_LOG_SIGN")?
                <Tooltip title="发起签署流程">
                    <Icon type="form" className="table-operate-icon" onClick={this.startFlow.bind(this, record)} />
                </Tooltip>
                :""}
                <Tooltip title="导出委托评估书">
                    <Icon type="download" className="table-operate-icon" onClick={this.download.bind(this, record, "entrust")} />
                </Tooltip>
                {
                    record.status === 2 ?
                        <Tooltip title="导出未签署的评估报告">
                            <Icon type="download" className="table-operate-icon" onClick={this.download.bind(this, record, "report")} />
                        </Tooltip>
                        : ''
                }
                {
                    record.signTaskStatus === 2 ?
                        <Tooltip title="导出已签署完成的评估报告">
                            <Icon type="download" className="table-operate-icon" onClick={this.download.bind(this, record, "finished")} />
                        </Tooltip>
                        : ''
                }

            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        loadingVisible: false,

        detailVisible: false,
        detailData: {},
    };


    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    hiddenModalDetail = () => {
        this.setState({ detailVisible: false, detailData: {} });
    };

    edit = (info, e) => {
        http.get({
            url: '/valuationApply/findValuationInfo',
            data: {
                id: info.id
            },
            success: (res) => {
                if (res != null) {
                    let image = res["image"];
                    res = res["data"];
                    res["image"] = image;
                    if (res["client"] == null || res["client"] === "") {
                        res["client"] = res["owner"];
                    }
                    if (res["valuationDate"] == null || res["valuationDate"] === "") {
                        res["valuationDate"] = moment();
                    }
                }
                this.setState({ editData: res, visible: true });
            }
        });
    }

    detail = (info, e) => {
        http.get({
            url: '/valuationApply/findValuationInfo',
            data: {
                id: info.id
            },
            success: (res) => {
                if (res != null) {
                    let image = res["image"];
                    res = res["data"];
                    res["image"] = image;
                }
                this.setState({ detailData: res, detailVisible: true });
            }
        });
    }

    /**
     * 导出数据
     * @param record 要导出数据
     * @param type 导出的类型 entrust ： 委托评估书， report：评估报告
     */
    download = (record, type, e) => {
        this.setState({ loadingVisible: true });
        let fileName = "车辆评估委托书.docx";
        let url = '/valuationApply/downloadEntrust';
        if (type === "report") {
            fileName = record["valuationNo"] + "车辆评估报告.docx";
            url = '/valuationApply/downloadValuation';
        }else if(type === "finished") {
            fileName = record["valuationNo"] + "车辆评估报告.pdf";
            url = '/valuationApply/downloadFinishedValuation';
            
        }
        http.download({
            url: url,
            data: { "id": record.id },
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    startFlow = (record) => {
        messager.confirm("是否发起该签署流程？", () => {
            this.setState({ loadingVisible: true });
            http.post({
                url: "/valuationApply/startFlow",
                data: { "id": record.id },
                success: (res) => {
                    messager.notify("发起成功，请注意查收短信！");
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    onSelect = (field, key) => {
        let queryData = this.state.queryData;
        queryData[field] = key;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车架号"
                                    onSearch={this.inputSearch.bind(this, "vin")}
                                    enterButton
                                    style={{ width: '200px' }}
                                />
                                <Input.Search
                                    placeholder="报告编码"
                                    onSearch={this.inputSearch.bind(this, "valuationNo")}
                                    enterButton
                                    style={{ margin: '0 10px', width: '200px' }}
                                />
                                {/* <DatePicker.RangePicker onChange={this.rangePickerChange}/> */}
                                <Select onChange={this.onSelect.bind(this, "status")} allowClear={true} style={{ width: '150px' }} >
                                    <Select.Option key="1">待评估</Select.Option>
                                    <Select.Option key="2">已评估</Select.Option>
                                </Select>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/valuationApply/findApplicationPage"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <MemberValuateDetail
                    visible={this.state.detailVisible}
                    onCancel={this.hiddenModalDetail.bind(this)}
                    editData={this.state.detailData}
                />
                <MemberValuateEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading visible={this.state.loadingVisible} message="数据处理中，请稍候..." />
            </div>
        )
    }
}

export default MemberValuateIndex;